var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserDetails(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_885",
    "data-name": "Group 885",
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.2,
    height: 36.119,
    viewBox: "0 0 26.7 26.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_883",
    "data-name": "Group 883",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M86.472,23.463a43.689,43.689,0,0,0-7.964-5.107.243.243,0,0,1-.141-.222v-5.4a2.51,2.51,0,0,0,1.125-2.1V5.04A5.041,5.041,0,0,0,74.452,0h-1.2a5.041,5.041,0,0,0-5.04,5.04v5.6a2.538,2.538,0,0,0,1.125,2.1v5.4a.236.236,0,0,1-.141.222,43.689,43.689,0,0,0-7.964,5.107,2.709,2.709,0,0,0-.984,2.095v3.834h5.137v-.429A2.311,2.311,0,0,1,67.229,26.7c.007-.022.022-.044.03-.067a2.312,2.312,0,0,1,.289-2.909l.622-.622a2.3,2.3,0,0,1,1.636-.681,2.259,2.259,0,0,1,1.288.392c.015-.007.037-.015.052-.022a2.317,2.317,0,0,1,2.265-1.865h.881A2.3,2.3,0,0,1,76.554,22.8c.015.007.03.007.037.015a2.3,2.3,0,0,1,2.924.274l.622.622a2.313,2.313,0,0,1,.281,2.931.125.125,0,0,1,.015.037,2.318,2.318,0,0,1,1.88,2.265v.444h5.137V25.55A2.676,2.676,0,0,0,86.472,23.463Z",
    transform: "translate(-60.249)",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_884",
    "data-name": "Group 884",
    transform: "translate(6.854 22.656)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M165.757,311.821h-.866a5.255,5.255,0,0,0-.844-2.021l.614-.614a.572.572,0,0,0,0-.807l-.622-.622a.572.572,0,0,0-.807,0l-.614.614a5.357,5.357,0,0,0-2.021-.836v-.866a.57.57,0,0,0-.57-.57h-.881a.57.57,0,0,0-.57.57v.859a5.342,5.342,0,0,0-2.028.836l-.607-.607a.572.572,0,0,0-.807,0l-.622.622a.572.572,0,0,0,0,.807l.6.6a5.4,5.4,0,0,0-.851,2.035h-.844a.57.57,0,0,0-.57.57v.881a.57.57,0,0,0,.57.57h.836a5.3,5.3,0,0,0,.844,2.043l-.585.592a.572.572,0,0,0,0,.807l.622.622a.572.572,0,0,0,.807,0l.585-.592a5.336,5.336,0,0,0,2.05.844v.836a.57.57,0,0,0,.57.57h.881a.57.57,0,0,0,.57-.57v-.844a5.4,5.4,0,0,0,2.035-.851l.6.6a.572.572,0,0,0,.807,0l.622-.622a.572.572,0,0,0,0-.807l-.607-.607a5.244,5.244,0,0,0,.829-2.035h.859a.57.57,0,0,0,.57-.57v-.881A.545.545,0,0,0,165.757,311.821Zm-4.086,3.086a2.931,2.931,0,1,1-.007-4.145A2.933,2.933,0,0,1,161.672,314.908Z",
    transform: "translate(-152.849 -306.1)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserDetails);
export default __webpack_public_path__ + "static/media/UserDetails.059d32d0172b2062a1e158b34e963a26.svg";
export { ForwardRef as ReactComponent };